import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const Default = ()=>{
    //ToDo: Article FED
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
